var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    transform: "matrix(-1 0 0 1 49.0002 0)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4002 33.9C23.4002 35.0598 24.3404 36 25.5002 36C26.66 36 27.6002 35.0598 27.6002 33.9V32.5456C28.0891 32.4001 28.5566 32.2052 28.9969 31.9666L29.955 32.9246C30.7751 33.7447 32.1048 33.7447 32.9249 32.9246C33.745 32.1045 33.745 30.7749 32.9249 29.9548L31.9668 28.9967C32.2054 28.5563 32.4004 28.0888 32.5459 27.6H33.9002C35.06 27.6 36.0002 26.6598 36.0002 25.5C36.0002 24.3402 35.06 23.4 33.9002 23.4H32.5459C32.4004 22.9112 32.2054 22.4437 31.9668 22.0033L32.9249 21.0452C33.745 20.2251 33.745 18.8955 32.9249 18.0754C32.1048 17.2553 30.7751 17.2553 29.955 18.0754L28.9969 19.0334C28.5566 18.7948 28.0891 18.5999 27.6002 18.4544V17.1C27.6002 15.9402 26.66 15 25.5002 15C24.3404 15 23.4002 15.9402 23.4002 17.1V18.4544C22.9114 18.5999 22.4439 18.7948 22.0035 19.0334L21.0455 18.0754C20.2254 17.2553 18.8957 17.2553 18.0756 18.0754C17.2555 18.8955 17.2555 20.2251 18.0756 21.0452L19.0337 22.0033C18.7951 22.4437 18.6001 22.9112 18.4546 23.4H17.1002C15.9404 23.4 15.0002 24.3402 15.0002 25.5C15.0002 26.6598 15.9404 27.6 17.1002 27.6H18.4546C18.6001 28.0888 18.7951 28.5563 19.0337 28.9967L18.0756 29.9548C17.2555 30.7749 17.2555 32.1045 18.0756 32.9246C18.8957 33.7447 20.2254 33.7447 21.0455 32.9246L22.0035 31.9666C22.4439 32.2052 22.9114 32.4001 23.4002 32.5456V33.9ZM25.5002 28.65C27.2399 28.65 28.6502 27.2397 28.6502 25.5C28.6502 23.7603 27.2399 22.35 25.5002 22.35C23.7605 22.35 22.3502 23.7603 22.3502 25.5C22.3502 27.2397 23.7605 28.65 25.5002 28.65Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.05c2039e1abb5c21cd3f91bdcb38de5e.svg";
export { ForwardRef as ReactComponent };